import React from 'react'
import LeftArrow from 'components/icons/LeftArrow'
import {
  Container,
  LeftSection,
  RightSection,
  SectionName,
  TopHeading,
  BreadMainSpan,
  BreadSubSpan,
  
} from './style'
import Button from 'components/Button'
import RoutePath from 'components/RoutePath'
import { useNavigate } from 'react-router-dom'

const Header = ({
  form,
  setIsFieldsMandatory,
  isEditing,
  eventStatus,
}) => {
  const navigate = useNavigate()

  const handleBackClick = () => {
    navigate(-1)
  }

  return (
    <Container spaceBetween>
      <LeftSection centerVertically>
        <div style={{ cursor: 'pointer' }}>
          <LeftArrow onClick={handleBackClick} />
        </div>
        <SectionName column>
          <TopHeading >
            <BreadMainSpan>Corporate /  </BreadMainSpan>
            <BreadSubSpan onClick={handleBackClick}> &nbsp;Listing</BreadSubSpan>
          </TopHeading>
          <TopHeading>{ !isEditing ? 'Add New Corporate' : 'Edit Corporate'} </TopHeading>
        </SectionName>
      </LeftSection>
      <RightSection>
        
          <Button.Primary
            text="Save"
            form={form}
            name="corporatesForm"

            htmlType="submit"
          />
     
      </RightSection>
    </Container>
  )
}
export default Header
